"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGE_TYPES = void 0;
exports.alignWidgetBelowButtonRow = alignWidgetBelowButtonRow;
exports.applyPageRuleOverrides = applyPageRuleOverrides;
exports.buildCheckoutLoaderUrl = buildCheckoutLoaderUrl;
exports.buildCheckoutMessage = buildCheckoutMessage;
exports.buildCheckoutPageUrl = buildCheckoutPageUrl;
exports.cssLoader = cssLoader;
exports.detectBrowser = detectBrowser;
exports.detectPage = detectPage;
exports.generateIframe = generateIframe;
exports.generateUrlWithParams = generateUrlWithParams;
exports.getBwaMutantSessionId = getBwaMutantSessionId;
exports.getCartPageUrl = getCartPageUrl;
exports.getCognitoLoginTreatment = getCognitoLoginTreatment;
exports.getEcpSessionId = getEcpSessionId;
exports.getEventExperimentFields = getEventExperimentFields;
exports.getEventExperiments = getEventExperiments;
exports.getExperimentContext = getExperimentContext;
exports.getQueryParam = getQueryParam;
exports.getRevampedAspTreatment = getRevampedAspTreatment;
exports.getRtoTreatment = getRtoTreatment;
exports.getUtmExperience = getUtmExperience;
exports.getVariantId = getVariantId;
exports.getVariantIdFromURL = getVariantIdFromURL;
exports.insertElementAsLastChild = insertElementAsLastChild;
exports.insertElementWithFallback = insertElementWithFallback;
exports.isAndroid = isAndroid;
exports.isBwARepeatCustomer = isBwARepeatCustomer;
exports.isCheckoutOfferingActive = isCheckoutOfferingActive;
exports.isCognitoLoginEnabled = isCognitoLoginEnabled;
exports.isEmbeddedCheckoutEnabled = isEmbeddedCheckoutEnabled;
exports.isMetaBrowser = isMetaBrowser;
exports.isRevampedAspEnabled = isRevampedAspEnabled;
exports.isWidgetWidthManagedByParent = isWidgetWidthManagedByParent;
exports.jsLoader = jsLoader;
exports.loadRfaScript = loadRfaScript;
exports.matchPageRule = matchPageRule;
exports.normalizeWidgetGap = normalizeWidgetGap;
exports.postMessageToIframe = postMessageToIframe;
exports.resolveWidgetAnchor = resolveWidgetAnchor;
exports.safeGetElementById = safeGetElementById;
exports.safeGetElementsByTagName = safeGetElementsByTagName;
exports.safeQuerySelector = safeQuerySelector;
exports.safeQuerySelectorAll = safeQuerySelectorAll;
exports.sendGaData = sendGaData;
exports.setBwaMutantSessionId = setBwaMutantSessionId;
exports.setCognitoLoginTreatment = setCognitoLoginTreatment;
exports.setEcpSessionId = setEcpSessionId;
exports.setEventExperiments = setEventExperiments;
exports.setRevampedAspTreatment = setRevampedAspTreatment;
exports.setRtoTreatment = setRtoTreatment;
exports.setStoreId = setStoreId;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _constants = require("../constants/constants");
var _gaClientIdManager = require("./ga-client-id-manager");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function generateUrlWithParams(baseUrl, params) {
  var url = new URL(baseUrl);
  var searchParams = new URLSearchParams(url.search);
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    searchParams.set(key, value);
  }
  url.search = searchParams.toString();
  return url.toString();
}
var BWA_SESSION_KEY = 'bwaSessionId';
function setBwaMutantSessionId(sessionId) {
  localStorage.setItem(BWA_SESSION_KEY, sessionId);
}
function getBwaMutantSessionId() {
  var urlParams = new URLSearchParams(window.location.search);
  var urlSessionId = urlParams.get(BWA_SESSION_KEY);
  if (urlSessionId) {
    setBwaMutantSessionId(urlSessionId);
    return urlSessionId;
  }
  try {
    var stored = localStorage.getItem(BWA_SESSION_KEY);
    // Legacy migration: older code stored sessionId as JSON ({id, expires}).
    // Clear it so the next validate call or URL param sets a fresh plain string.
    if (stored && stored.charAt(0) === '{') {
      localStorage.removeItem(BWA_SESSION_KEY);
      return null;
    }
    return stored;
  } catch (e) {
    console.warn('Failed to access bwaSessionId in localStorage', e);
    return null;
  }
}
function setEcpSessionId(sessionId) {
  if (!sessionId) return;
  try {
    if (!sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID)) {
      sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID, sessionId);
    }
  } catch (e) {
    console.warn('Failed to set ecpSessionId in sessionStorage', e);
  }
}
function getEcpSessionId() {
  try {
    return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID);
  } catch (e) {
    console.warn('Failed to access ecpSessionId in sessionStorage', e);
    return null;
  }
}
function isBwARepeatCustomer() {
  try {
    return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_REPEAT_CUSTOMER) === "true";
  } catch (e) {
    return false;
  }
}
function appendSessionIdToUrl(url) {
  if (!url) return url;
  try {
    var urlObj = new URL(url);
    var sessionId = getBwaMutantSessionId();
    if (sessionId) {
      urlObj.searchParams.set(BWA_SESSION_KEY, sessionId);
    }
    var ecpSessionId = getEcpSessionId();
    if (ecpSessionId) {
      urlObj.searchParams.set(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID, ecpSessionId);
    }
    return urlObj.toString();
  } catch (e) {
    return url;
  }
}
function generateIframe(id, cssClass, src) {
  var sandbox = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var iframe = document.createElement('iframe');
  iframe.id = id;
  iframe.classList.add(cssClass);
  iframe.src = appendSessionIdToUrl(src);
  if (sandbox) iframe.sandbox = sandbox;
  return iframe;
}
function setRtoTreatment(treatment) {
  if (treatment) {
    sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.RTO_TREATMENT, treatment);
  }
}
function getRtoTreatment() {
  return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.RTO_TREATMENT);
}
function setCognitoLoginTreatment(treatment) {
  if (treatment) {
    sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.COGNITO_LOGIN_TREATMENT, treatment);
  }
}
function getCognitoLoginTreatment() {
  return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.COGNITO_LOGIN_TREATMENT);
}
function setRevampedAspTreatment(treatment) {
  if (treatment) {
    sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.REVAMPED_ASP_TREATMENT, treatment);
  }
}
function getRevampedAspTreatment() {
  return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.REVAMPED_ASP_TREATMENT);
}

// Cognito phone+OTP login is active only for the T1 treatment.
function isCognitoLoginEnabled() {
  return getCognitoLoginTreatment() === _constants.TREATMENTS.T1;
}

// Revamped ASP / embedded checkout page is active only for the T1 treatment.
function isRevampedAspEnabled() {
  return getRevampedAspTreatment() === _constants.TREATMENTS.T1;
}

// Embedded checkout is shown when Cognito login is on, OR when the revamped ASP is on for an
// already-resolved repeat/CIT customer (resolveCustomer true, cached before the checkout click).
function isEmbeddedCheckoutEnabled() {
  return isCognitoLoginEnabled() || isRevampedAspEnabled() && isBwARepeatCustomer();
}
function isCheckoutOfferingActive() {
  var _window$bwaValidateSt;
  var offerings = (_window$bwaValidateSt = window.bwaValidateStoreResponse) === null || _window$bwaValidateSt === void 0 ? void 0 : _window$bwaValidateSt.bwaOfferings;
  if (!offerings) return true; // backward compatible: legacy merchants without offerings data
  return offerings.CHECKOUT;
}

/**
 * Persists the full validate-store `treatments` map for event enrichment.
 * Events-only — behaviour gating keeps using the dedicated per-experiment setters above.
 * Never throws: telemetry must not break the storefront.
 *
 * sessionStorage deliberately, NOT localStorage. The Shopify checkout pixel
 * (BwAShopifyScripts) also reads this key, and checkout is same-origin with the storefront, so
 * a same-tab journey keeps it. Session scope is what makes it correct: the cohort dies with the
 * tab, so a later visit can never be attributed to an earlier visit's treatment. In localStorage
 * this value has no expiry and would need explicit invalidation on every path that fails to
 * refresh it. Worst case here is missing attribution (recoverable by joining the purchase to the
 * session's storefront events on ga_session_id), never wrong attribution.
 */
function setEventExperiments(treatments) {
  if (!treatments) return;
  try {
    sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.BWA_EVENT_EXPERIMENTS, JSON.stringify(treatments));
  } catch (e) {
    // Ignored.
  }
}

/**
 * Persists the BwA store id so the Shopify checkout pixel can stamp `ecp_store_id` on checkout
 * events, which carry no BwA payload of their own. sessionStorage for the same reason as the
 * treatments map above; the pixel falls back to init.data.shop.myshopifyDomain when absent.
 * Never throws.
 */
function setStoreId(storeId) {
  if (!storeId) return;
  try {
    sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.BWA_STORE_ID, storeId);
  } catch (e) {
    // Ignored.
  }
}

/**
 * Full `treatments` map for the current session, or null.
 * The in-page validate-store response is authoritative for this page load; sessionStorage is
 * the fallback for events that fire before it resolves (watchers attach on DOMContentLoaded,
 * independently of the async validate call).
 */
function getEventExperiments() {
  var _window$bwaValidateSt2;
  var treatments = (_window$bwaValidateSt2 = window.bwaValidateStoreResponse) === null || _window$bwaValidateSt2 === void 0 ? void 0 : _window$bwaValidateSt2.treatments;
  if (treatments) return treatments;
  try {
    var raw = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.BWA_EVENT_EXPERIMENTS);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

/**
 * Experiment fields shared by every event path: one `exp_<experiment>` param per experiment
 * plus the legacy aggregate `experiments` JSON string (omitted when there are none).
 *
 * The per-experiment params exist because GA4 truncates a single param value at 100 chars —
 * the aggregate string becomes unreliable once a handful of experiments run concurrently.
 * Keys are dash→underscore normalized; unassigned (null) treatments are skipped.
 */
function getEventExperimentFields() {
  var treatments = getEventExperiments();
  if (!treatments) return {};
  var experiments = {};
  var fields = {};
  for (var _i2 = 0, _Object$entries2 = Object.entries(treatments); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i2], 2),
      experimentId = _Object$entries2$_i[0],
      treatment = _Object$entries2$_i[1];
    if (treatment) {
      var experimentKey = experimentId.replace(/-/g, '_');
      experiments[experimentKey] = treatment;
      fields["exp_".concat(experimentKey)] = treatment;
    }
  }
  if (Object.keys(experiments).length > 0) {
    fields.experiments = JSON.stringify(experiments);
  }
  return fields;
}
function getExperimentContext() {
  var sessionId = getBwaMutantSessionId();
  // `experiments` defaults to an empty map so the field is always present for existing
  // dashboards; getEventExperimentFields overrides it whenever experiments are assigned.
  return _objectSpread({
    bwa_session_id: sessionId,
    experiments: '{}'
  }, getEventExperimentFields());
}

/**
 * Experience override for validate-store. Prefers the URL param so a fresh `?utm_experience=`
 * always wins, then falls back to the value BwAUtmScript mirrored into sessionStorage earlier
 * in the session. Horizonte ignores values outside its experience enum.
 */
function getUtmExperience() {
  try {
    var fromUrl = new URLSearchParams(window.location.search).get(_constants.QUERY_PARAMS.UTM_EXPERIENCE);
    return fromUrl || sessionStorage.getItem(_constants.QUERY_PARAMS.UTM_EXPERIENCE);
  } catch (e) {
    return null;
  }
}
function getQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

// Page types that detectPage() may return and that app.js knows how to route.
var PAGE_TYPES = exports.PAGE_TYPES = ["Home", "PDP", "Cart"];
function isPlainObject(value) {
  return value !== null && (0, _typeof2["default"])(value) === "object" && !Array.isArray(value);
}

// Recursively merges plain objects. Arrays and scalars from `source` replace `target`.
function deepMerge(target, source) {
  if (!isPlainObject(target) || !isPlainObject(source)) {
    return source;
  }
  var output = _objectSpread({}, target);
  for (var _i3 = 0, _Object$keys = Object.keys(source); _i3 < _Object$keys.length; _i3++) {
    var key = _Object$keys[_i3];
    output[key] = deepMerge(target[key], source[key]);
  }
  return output;
}

// Returns the first pageRule whose pattern matches the current path, or null.
// Ordered, first-match-wins. A malformed rule (non-string pattern, unknown type, or a
// pattern that fails to compile) is skipped so a bad rule can never throw.
function matchPageRule() {
  var normalizedPath = window.location.pathname.replace(/\/+$/, '');
  var pageRules = window.bwaMerchantConfig && window.bwaMerchantConfig.pageRules;
  if (!Array.isArray(pageRules)) {
    return null;
  }
  var _iterator = _createForOfIteratorHelper(pageRules),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      if (!rule || typeof rule.pattern !== "string" || PAGE_TYPES.indexOf(rule.type) === -1) {
        continue;
      }
      try {
        if (new RegExp(rule.pattern).test(normalizedPath)) {
          return rule;
        }
      } catch (error) {
        console.error("BwA: skipping invalid pageRule pattern \"".concat(rule.pattern, "\""), error);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}

// Merges a matched pageRule's optional `overrides` into window.bwaMerchantConfig so the
// page flows read page-appropriate selectors — e.g. a /pages/<vanity> layout whose mount
// anchors or variant-id selector differ from the native PDP theme. No-op when the rule
// has no (or a non-object) `overrides`, so merchants relying on their default config are
// unaffected.
function applyPageRuleOverrides(rule) {
  var overrides = rule && rule.overrides;
  if (!isPlainObject(overrides)) {
    return;
  }
  window.bwaMerchantConfig = deepMerge(window.bwaMerchantConfig || {}, overrides);
}

// Config-driven page rules take precedence (see matchPageRule); with no matching rule we
// fall through to the default path-based detection, so merchants without pageRules are
// unaffected.
function detectPage() {
  var matchedRule = matchPageRule();
  if (matchedRule) {
    return matchedRule.type;
  }

  // Default detection (unchanged fallback).
  var normalizedPath = window.location.pathname.replace(/\/+$/, '');
  if (normalizedPath === '' || normalizedPath === '/index') {
    return "Home";
  }
  if (normalizedPath.includes('/products')) {
    return "PDP";
  }
  if (normalizedPath.startsWith('/cart')) {
    return "Cart";
  }
  return "Unknown";
}
function postMessageToIframe(id) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var iframe = safeGetElementById(id);
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(message, '*');
  }
}
function buildCheckoutMessage(_ref) {
  var cartDetails = _ref.cartDetails,
    storeUrl = _ref.storeUrl,
    storeId = _ref.storeId,
    ecp = _ref.ecp,
    _ref$extraFields = _ref.extraFields,
    extraFields = _ref$extraFields === void 0 ? {} : _ref$extraFields;
  return _objectSpread({
    cartDetails: cartDetails,
    ecp: ecp,
    storeUrl: storeUrl,
    shopId: storeId,
    clientId: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.CLIENT_ID),
    gaClientId: _gaClientIdManager.GaClientIdManager.getGaClientId(),
    ecpSessionId: getEcpSessionId(),
    address: {
      pincode: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.PINCODE)
    }
  }, extraFields);
}

// Builds the /checkout-page URL opened inside the embedded overlay. The cart is already created
// (checkoutId) and returnUrl points at the ECP checkout to resume on completion. bwaSessionId is
// appended at iframe creation time (see generateIframe -> appendSessionIdToUrl).
function buildCheckoutPageUrl(_ref2) {
  var checkoutId = _ref2.checkoutId,
    returnUrl = _ref2.returnUrl,
    ecpCustomerId = _ref2.ecpCustomerId,
    ecpSessionId = _ref2.ecpSessionId;
  return buildEmbeddedCheckoutUrl(_constants.WIDGET_ENDPOINTS.CHECKOUT_PAGE, {
    checkoutId: checkoutId,
    returnUrl: returnUrl,
    ecpCustomerId: ecpCustomerId,
    ecpSessionId: ecpSessionId
  });
}

// Builds the /checkout-loader (interstitial splash) URL. Same params as the checkout page — the
// loader forwards them verbatim to /checkout-page after its client-side auth check. Used only for
// the Cognito login experience; the repeat-CX embedded path opens /checkout-page directly.
function buildCheckoutLoaderUrl(_ref3) {
  var checkoutId = _ref3.checkoutId,
    returnUrl = _ref3.returnUrl,
    ecpCustomerId = _ref3.ecpCustomerId,
    ecpSessionId = _ref3.ecpSessionId;
  return buildEmbeddedCheckoutUrl(_constants.WIDGET_ENDPOINTS.CHECKOUT_LOADER, {
    checkoutId: checkoutId,
    returnUrl: returnUrl,
    ecpCustomerId: ecpCustomerId,
    ecpSessionId: ecpSessionId
  });
}

// Shared builder for the embedded checkout entry URLs. ecp + ecpShopId are baked into the endpoint
// constant (consistent with the other widget endpoints), so only the per-checkout params are added.
function buildEmbeddedCheckoutUrl(baseEndpoint, _ref4) {
  var checkoutId = _ref4.checkoutId,
    returnUrl = _ref4.returnUrl,
    ecpCustomerId = _ref4.ecpCustomerId,
    ecpSessionId = _ref4.ecpSessionId;
  var params = {
    shopId: window.storeId,
    checkoutId: checkoutId || '',
    returnUrl: returnUrl || '',
    ecpCustomerId: ecpCustomerId || _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID,
    ecpSessionId: ecpSessionId || '',
    gaClientId: _gaClientIdManager.GaClientIdManager.getGaClientId() || ''
  };
  var qs = Object.keys(params).filter(function (k) {
    return params[k] !== '';
  }).map(function (k) {
    return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(params[k]));
  }).join('&');
  return "".concat(baseEndpoint, "&").concat(qs);
}
function cssLoader(fileUrl) {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = fileUrl;
  link.onerror = function () {
    return console.error("[BwA] Failed to load CSS file:", fileUrl);
  };
  document.head.appendChild(link);
}
function jsLoader(url) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    script.defer = true;
    script.onload = function () {
      resolve();
    };
    script.onerror = function () {
      reject(new Error("[BwA] Failed to load script: ".concat(url)));
    };
    document.head.appendChild(script);
  });
}
function getVariantId(variantIdSelector) {
  var element = safeQuerySelector(variantIdSelector);
  return element === null || element === void 0 ? void 0 : element.value;
}
function getVariantIdFromURL() {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}
function insertElementWithFallback(containerId, bwaWidget, fallbackElement) {
  var widgetContainer = safeGetElementById(containerId);
  if (widgetContainer) {
    widgetContainer.appendChild(bwaWidget);
  } else {
    var preSiblingElement = safeQuerySelector(fallbackElement);
    if (preSiblingElement) {
      var _preSiblingElement$pa;
      (_preSiblingElement$pa = preSiblingElement.parentNode) === null || _preSiblingElement$pa === void 0 || _preSiblingElement$pa.insertBefore(bwaWidget, preSiblingElement.nextSibling);
    }
  }
}
function insertElementAsLastChild(selector, element) {
  var container = safeQuerySelector(selector);
  if (container) {
    container.appendChild(element);
  }
}
function safeQuerySelectorAll(selector) {
  return selector !== null && selector !== void 0 && selector.trim() ? document.querySelectorAll(selector) : [];
}
function safeQuerySelector(selector) {
  return selector ? document.querySelector(selector) : null;
}
function safeGetElementById(id) {
  return id ? document.getElementById(id) : null;
}
function safeGetElementsByTagName(tagName) {
  return tagName ? document.getElementsByTagName(tagName) : [];
}
function getCartPageUrl() {
  return window.location.origin + '/cart';
}
function isMetaBrowser() {
  return /Instagram|FBAN|FBAV/i.test(navigator.userAgent);
}
function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

// Classify browser from UA. Order matters: in-app wrappers/WebViews contain 'Chrome/', so check them before the chrome fallback.
function detectBrowser(ua) {
  if (!ua) return "unknown";
  if (/Instagram/i.test(ua)) return "instagram";
  if (/FBAN|FBAV|FB_IAB|FB4A/i.test(ua)) return "facebook";
  if (/EdgA?\//i.test(ua)) return "edge";
  if (/OPR\/|Opera/i.test(ua)) return "opera";
  if (/SamsungBrowser/i.test(ua)) return "samsung";
  if (/MiuiBrowser/i.test(ua)) return "miui";
  if (/UCBrowser/i.test(ua)) return "uc";
  if (/FxiOS|Firefox\//i.test(ua)) return "firefox";
  if (/CriOS/i.test(ua)) return "chrome_ios";
  if (/\bwv\b/i.test(ua)) return "android_webview";
  if (/Chrome\//i.test(ua)) return "chrome";
  if (/Version\/.*Safari/i.test(ua)) return "safari";
  return "other";
}
function loadRfaScript(scriptSrc, roaInstanceId) {
  if (!safeQuerySelector("script[src=\"".concat(scriptSrc, "\"]"))) {
    var script = document.createElement('script');
    script.type = 'module';
    script.src = scriptSrc;
    script.defer = true;
    script.setAttribute('data-target-id', roaInstanceId);
    document.head.appendChild(script);
  }
}
function sendGaData(eventName, gaPayload) {
  var _window$Shopify;
  if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.analytics) !== null && _window$Shopify !== void 0 && _window$Shopify.publish) {
    Shopify.analytics.publish(eventName, _objectSpread(_objectSpread({
      ecp: _constants.ECP,
      ecp_store_id: window.storeId,
      is_meta_browser: String(isMetaBrowser())
    }, getExperimentContext()), gaPayload));
  }
}

// Widget Placement Utilities

var WIDGET_GAP = 1;

/**
 * Determines where to insert a widget iframe relative to a button.
 * Handles custom elements, multi-column grids, flex-row, and block layouts.
 *
 * @param {HTMLElement} button
 * @returns {{ anchor: HTMLElement, escaped: boolean }}
 *   escaped: true when iframe is placed outside the button's parent (needs centering and width adjustment)
 */
function resolveWidgetAnchor(button) {
  var buttonParent = button.parentElement;
  if (!buttonParent) return {
    anchor: button,
    escaped: false
  };

  // Custom elements (tag has '-') may have shadow DOM — escape all nested ones
  if (buttonParent.tagName.includes('-')) {
    var anchor = buttonParent;
    while (anchor.parentElement && anchor.parentElement.tagName.includes('-')) {
      anchor = anchor.parentElement;
    }
    return {
      anchor: anchor,
      escaped: true
    };
  }
  var parentStyle = getComputedStyle(buttonParent);

  // Multi-column grid — inserting inside would land in wrong cell
  if (parentStyle.display.includes('grid')) {
    var gridColumnCount = parentStyle.gridTemplateColumns.split(/\s+/).filter(Boolean).length;
    if (gridColumnCount > 1) {
      return {
        anchor: buttonParent,
        escaped: true
      };
    }
  }

  // Flex-row — inserting inside would place widget beside buttons, not below
  var isFlexRow = parentStyle.display.includes('flex') && (!parentStyle.flexDirection || parentStyle.flexDirection === 'row' || parentStyle.flexDirection === 'row-reverse');
  if (isFlexRow) {
    return {
      anchor: buttonParent,
      escaped: true
    };
  }
  return {
    anchor: button,
    escaped: false
  };
}

/**
 * Styles the iframe to span the full button area and center below both buttons.
 * Also reduces excessive gap between the button row and the widget.
 *
 * @param {HTMLIFrameElement} iframe
 * @param {HTMLElement} buttonParent - The escaped container
 * @param {number} buttonWidth - The button's width in pixels
 */
function alignWidgetBelowButtonRow(iframe, buttonParent, buttonWidth) {
  var hasMultipleChildren = getVisibleChildren(buttonParent).length > 1;
  if (hasMultipleChildren) {
    iframe.style.width = getChildrenSpanWidth(buttonParent) + 'px';
  } else {
    iframe.style.width = buttonWidth + 'px';
  }
  iframe.style.display = 'block';
  iframe.style.margin = '0 auto';
}

/**
 * Normalizes the gap between the anchor element and the widget to WIDGET_GAP.
 * For flex/grid parents, reads the CSS gap; for others, reads margin-bottom.
 * CSS gap only creates visual spacing on flex/grid/multi-column containers,
 * so it is ignored for block layouts to avoid incorrect negative margins.
 *
 * @param {HTMLIFrameElement} iframe
 * @param {HTMLElement} referenceElement - The element above the iframe (button or its parent)
 */
function normalizeWidgetGap(iframe, referenceElement) {
  if (!(referenceElement !== null && referenceElement !== void 0 && referenceElement.parentElement)) {
    iframe.style.marginTop = "".concat(WIDGET_GAP, "px");
    return;
  }
  var parentStyle = getComputedStyle(referenceElement.parentElement);
  var elementStyle = getComputedStyle(referenceElement);
  var isFlexOrGrid = parentStyle.display.includes('flex') || parentStyle.display.includes('grid');
  var spacing = (isFlexOrGrid ? parseFloat(parentStyle.gap) : 0) || parseFloat(elementStyle.marginBottom) || 0;
  if (spacing > WIDGET_GAP) {
    iframe.style.marginTop = "-".concat(spacing - WIDGET_GAP, "px");
  } else {
    iframe.style.marginTop = "".concat(WIDGET_GAP, "px");
  }
}

/**
 * Returns true if the iframe width is managed by alignWidgetBelowButtonRow
 * (tracks parent scrollWidth, not button width).
 */
function isWidgetWidthManagedByParent(iframe, buttonParent) {
  if (!buttonParent || getVisibleChildren(buttonParent).length <= 1) return false;
  return iframe.style.width === getChildrenSpanWidth(buttonParent) + 'px';
}
function getVisibleChildren(parent) {
  return Array.from(parent.children).filter(function (el) {
    if (el.getBoundingClientRect().width === 0) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  });
}
function getChildrenSpanWidth(parent) {
  var visible = getVisibleChildren(parent);
  var firstChild = visible[0];
  var lastChild = visible[visible.length - 1];
  return lastChild.getBoundingClientRect().right - firstChild.getBoundingClientRect().left;
}
//# sourceMappingURL=utils.js.map
